import { orderBy } from 'lodash';

export const isFederalLevel = drugListMaps => drugListMaps.some(drugListMap => drugListMap.stateCd === null);

export const isMedicationAvailable = (drugListMaps, serviceLine) => {
  if (['general_medical', 'dermatology', 'primary_care'].includes(serviceLine)) {
    return !isFederalLevel(drugListMaps);
  }

  if (serviceLine === 'mental_health') {
    return drugListMaps.length > 0;
  }
};

export const getManagedStates = (drugListMaps, refStates) => {
  return orderBy(
    drugListMaps
      .map(drugListMap => refStates.find(refState => refState.stateCd === drugListMap.stateCd))
      .filter(refState => !!refState),
    'stateName'
  );
};
